import React from 'react';
import './Blank.css';
function Blank(){
    return(
        <div className='blank__one'>
            <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 319"><path fill="#ffff"
      fill-opacity="1" d="M0,192L48,176C96,160,192,128,288,128C384,128,480,160,576,181.3C672,203,768,213,864,186.7C960,160,1056,96,1152,80C1248,64,1344,96,1392,112L1440,128L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z">
        </path></svg> 
        <div className='blank__two'>
            </div>
            <div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#2f368e" fill-opacity="1" d="M0,224L60,202.7C120,181,240,139,360,144C480,149,600,203,720,234.7C840,267,960,277,1080,250.7C1200,224,1320,160,1380,128L1440,96L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z"></path></svg>
          </div>
        </div>
       
    )
  
}
export default Blank;